import React, { useState, useEffect } from "react";
import { getAxiosResponse, putAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import {  useTranslation } from 'react-i18next';
import i18next from "i18next";
import BidAlerts from "./BidAlerts";
import { useSelector } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import { transformBlankToNull } from "../../../services/Util";
import { handleError } from "../../../services/authApiRoutes/APImethods";
export default function Estimate(prop) {
  const translationEngineDisplay = prop.projectDetail.resource.projectResource.translationEngineType.display;
  const translationEngineName = translationEngineDisplay.split(' ')[0];
  const [machineTranslationRequest, setMachineTranslationRequest] = useState(
    []
  );
  const param = useParams();
  const [popupStatus, setPopupStatus] = useState("");
  const [rejectReason,setRejectReason] = useState('')
  const custBootstrapDataRedux = useSelector(store => store.customer_bootstrap_data).value;
  const getData = () =>{
    getAxiosResponse(APIUrls.GET_MACHINE_TRANSLATOR_REQUEST(param.id))
      .then((res) => {
        if (res.data !== "") {
          setMachineTranslationRequest(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  }
  const { t } = useTranslation();
  const translate = t;
  const messages = {
    "PENDING":"Preparing Translation Request",
    "QUOTED":"Awaiting quote acceptance",
    "ACCEPTED":"Machine Translation Request Accepted",
    "REJECTED":"Machine Translation Request Rejected"
  }
  useEffect(() => {
    getData()
  }, []);
  const showModel = () => {
    document.body.classList.add("modal-open");
  };
  const hideModel = () => {
    document.body.classList.remove("modal-open");
  };
  const showPopup = (status) => {
    setPopupStatus(status);
    showModel();
  };
  const rejectTranslationQuote = () => {
    machineTranslationRequest.status = "REJECTED"
    machineTranslationRequest.rejectionReason= rejectReason
    var payload = transformBlankToNull(machineTranslationRequest)
    putAxiosResponse(APIUrls.GET_MACHINE_TRANSLATOR_REQUEST(param.id),payload)
    .then((res)=>{
        hideModel()
        setPopupStatus('')
        prop.refresh('machineTranslation')
    })
  };
  const acceptTranslationQuote = () => {
    machineTranslationRequest.status = "ACCEPTED"
    var payload = transformBlankToNull(machineTranslationRequest)
    putAxiosResponse(APIUrls.GET_MACHINE_TRANSLATOR_REQUEST(param.id),payload)
    .then((res)=>{
      hideModel()
      setPopupStatus('')
      prop.refresh('machineTranslation')
    })

  }
  const addRejectReason = (value) => {
    setRejectReason(value)
  };

  return (
    prop.projectDetail?.displayName[0].status.code !== "preparing_project_tm" ?
    <div className="listing-content relative">
        {prop.projectDetail?.displayName[0].status.isProjectPreparing ?  
         <div className="campaign_details-task campaign-form">
            <p>OPAL-Marketing is preparing a machine translation quote for this project. Check back in a few minutes</p>
         </div>
        :
      <div className="campaign_details-task campaign-form">
        
        <div>
          <p>
            <b>Request Status :</b>{" "}
            {messages[machineTranslationRequest?.status?.code]}{" "}
          </p>
          <p>
          { i18next.t('estimate_machine_translation_quote_text', { 0: translationEngineName})}
          </p>
          {machineTranslationRequest?.status?.code === "REJECTED" && machineTranslationRequest?.rejectionReason !== '' ?
          <p>
          <b>Rejection reason :</b>{" "}
          {machineTranslationRequest.rejectionReason}{" "}
        </p> : ''
        }
        </div>
        <div className="projects-content">
          <div className="table-responsive global-table">
            <table className="sortable estimate-table mar-bot30" aria-label="Translation Request">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="no-sort"
                    tabIndex={0}
                    aria-label="First Translation Deadline"
                  >
                    Language
                  </th>
                  <th
                    scope="col"
                    className="no-sort"
                    tabIndex={0}
                    aria-label="Requested Date"
                  >
                    Estimated character count
                  </th>
                  <th
                    scope="col"
                    className="no-sort"
                    tabIndex={0}
                    aria-label="Preferred Vendor"
                  >
                    Subtotal
                  </th>
                </tr>
              </thead>

              {machineTranslationRequest.requestLanguages !== undefined ? (
                <tbody>
                  {machineTranslationRequest.requestLanguages.map(
                    (request, index) => {
                      return (
                        <tr key={index}>
                          <td tabIndex={0} aria-label={request.language}>
                            {request.language}{" "}
                          </td>
                          <td
                            tabIndex={0}
                            aria-label={`number of charachters ${request.numChars}`}
                          >
                            {request.numChars}{" "}
                          </td>
                          <td
                            tabIndex={0}
                            aria-label={request.quoteValue.value}
                          >
                            ${request.quoteValue.value}
                          </td>
                        </tr>
                      );
                    }
                  )}
                  <tr>
                    <td>
                      <b>Estimated total</b>
                    </td>
                    <td></td>
                    <td>
                      <b>$ {machineTranslationRequest.quoteValue.value}</b>
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                    <tr><td colSpan={6}><div className="no-data-display align-center"><i className="nodata-icon"></i></div></td>
                </tr>
                </tbody>
                
              )}
            </table>
            {machineTranslationRequest.status?.code ===
            "QUOTED" ? (
              <div className="flex justify-end btn-gap">
                <button className="blue-btn active" onClick={() => showPopup("accept")}>
                  Accept
                </button>
                <button className="blue-btn " onClick={() => showPopup("reject")}>
                  Reject
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
}
      
        <div id="modelPopup" className="lightbox-panel approved-popup ">
          <div className="inner-lightbox-panel">
            <div className="modal-header flex">
              <strong>
                {popupStatus === "accept"
                  ? "Confirmation"
                  : popupStatus === "reject"
                  ? "Reject Machine Translation Quote"
                  : ""}
              </strong>
              <button
                className="close"
                aria-label="close right popup"
                onClick={hideModel}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                >
                  <path
                    d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z"
                    fill="white"
                  ></path>
                  <path
                    d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z"
                    fill="white"
                  ></path>
                </svg>
              </button>
            </div>
            {popupStatus === "reject" ? (
              <>
                <div className="lightbox-content">
                  <p>
                    Rejecting the price quote will cancel this project. This
                    action cannot be undone. You may optionally provide a reason
                    for rejecting this request.
                  </p>
                  <div className="translate-box flex"></div>
                  <div className="form-group">
                    <div className="form-text">
                      <textarea
                        className="textarea form-control-sm"
                        placeholder="500 characters limit"
                        maxLength={500}
                        onChange={(event) =>
                          addRejectReason(event.target.value)
                        }
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="modal-footer flex">
                  <button
                    className="btn btn-bold active"
                    onClick={rejectTranslationQuote}
                  >
                    Submit
                  </button>
                  <button className="btn btn-bold" onClick={hideModel}>
                    Cancel
                  </button>
                </div>
              </>
            ) : popupStatus === "accept" ? (
              <>
                <div className="lightbox-content">
                  <p>
                    Click Accept to accept the machine translation request and
                    start the translation process. By clicking Accept, you are
                    committing to all applicable charges from {translationEngineName} Translator
                    . This action is not reversible.
                  </p>
                </div>
                <div className="modal-footer flex">
                  <button className="btn btn-bold" onClick={acceptTranslationQuote}>
                    Accept
                  </button>
                  <button className="btn btn-bold" onClick={hideModel}>
                    Cancel
                  </button>
                </div>
              </>
            ) : ''}
          </div>
        </div>
      
    </div> : 
    <div className="listing-content relative">
    <h4>{translate("machine_translation_estimate_msg")}</h4>
  </div>
  );
}
